import {DomainAncestor, entityConfig, fieldInfo} from "core/common/domain/DomainAncestor";
import {observable, ObservableMap} from "mobx";
import {LovItem, default as MdEntity} from "core/metamodel/mdEntity";
import {IDomainObject} from "core/form/formUtils";
import {ID} from "core/metamodel/metaConstant";
import {DocumentTemplateResource, Document} from "core/document/documentDomain";
import mdEntityService from "core/metamodel/mdEntityService";
import {SEVERITY, ValidationMessage} from "core/common/domain/commonDomain";
import {GridParams} from "core/grid/domain/grid";


export enum EVENTCATEGORY {
  INFO_EVENT = "INFO_EVENT",
  DATA_EVENT = "DATA_EVENT",
  EMAIL_EVENT = "EMAIL_EVENT",
  PRINT_EVENT = "PRINT_EVENT",
  VOLVO_MQ_EVENT = "VOLVO_MQ_EVENT",
  SFTP_EVENT = "SFTP_EVENT",
  SMS_EVENT = "SMS_EVENT",
  VIBER_EVENT = "VIBER_EVENT"
}



export const EVENTCATEGORY_MAP: {[key in EVENTCATEGORY] : {icon: string}} = {
  INFO_EVENT: {icon: "Message"},
  DATA_EVENT: {icon: "Edit"},
  EMAIL_EVENT: {icon: "Email"},
  PRINT_EVENT: {icon: "Print"},
  VOLVO_MQ_EVENT: {icon: "Send"},
  SFTP_EVENT: {icon: "Send"},
  SMS_EVENT: {icon: "SmsMessage"},
  VIBER_EVENT: {icon: "SmsMessage"}

};


export enum EVENTTYPE {
  INVOICE_CONCEPT_SENT_EMAIL = "INVOICE_CONCEPT_SENT_EMAIL",
  INVOICE_SENT_EMAIL = "INVOICE_SENT_EMAIL",
  INVOICE_SENT_PRINT = "INVOICE_SENT_PRINT",
  INVOICE_SENT_ACCOUNTING = "INVOICE_SENT_ACCOUNTING",
  INVOICE_SENT_TAX_OFFICE = "INVOICE_SENT_TAX_OFFICE",
  INVOICE_SENT_ARCHIVE = "INVOICE_SENT_ARCHIVE",
  INVOICE_GENERATED = "INVOICE_GENERATED",
  INVOICE_INTERNAL_EMAIL = "INVOICE_INTERNAL_EMAIL",
  PROCESS_BRIMMESSAGE="PROCESS_BRIMMESSAGE",
  BRIMMESSAGE_NOTIFICATION="BRIMMESSAGE_NOTIFICATION",

  // treba party, product, vehicle
  INFO = "INFO",
  DML = "DML",
  OPEN = "OPEN",
  CLOSE = "CLOSE",
  SCHEDULED = "SCHEDULED",

  // treba invoice
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
  REOPENED = "REOPENED",

  SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS = "SHIPMENT_GATE_ARRIVAL_TO_DRIVER_SMS",
  SHIPMENT_GATE_ARRIVAL_TO_VENDOR_SMS = "SHIPMENT_GATE_ARRIVAL_TO_VENDOR_SMS",

  ACC_DOCUMENT_CONCEPT_SENT_EMAIL = "ACC_DOCUMENT_CONCEPT_SENT_EMAIL",
  ACC_DOCUMENT_SENT_EMAIL = "ACC_DOCUMENT_SENT_EMAIL",
  ACC_DOCUMENT_SENT_PRINT = "ACC_DOCUMENT_SENT_PRINT",
  ACC_DOCUMENT_SENT_ACCOUNTING = "ACC_DOCUMENT_SENT_ACCOUNTING"

}


export enum SENDTYPE {
  POST = "POST",
  EMAIL = "EMAIL",
}

export enum DMLOPERATION {
  INSERT = "INSERT",
  UPDATE = "UPDATE",
  DELETE = "DELETE"
}

export enum RECIPIENTTYPE {
  TO = "TO",
  CC = "CC",
  BCC = "BCC"
}

export enum ACTIVITYTYPE {
  EMAIL = "EMAIL",
  MEETING = "MEETING",
  PHONE = "PHONE",
  SMS = "SMS",
  USERMESSAGE = "USERMESSAGE"
}

export const ACTIVITYTYPE_MAP: {[key: string] : {icon: string}} = {
  EMAIL: {icon: "Email"}
};

export enum ACTIVITYLOCATION {
  Vehicle = "Vehicle",
  Customer = "Customer",
}


export enum ACTIVITYCATEGORY {
  MULTIEMAIL = "MULTIEMAIL",
  TASK = "TASK",
  PRODUCTVEHICLECHANGE = "PRODUCTVEHICLECHANGE",
  CUSTOMERREGISTRATION = "CUSTOMERREGISTRATION"
}


export enum TASKTYPE {
  TODO = "TODO",
  VEHICLE_NOTIFICATION = "VEHICLE_NOTIFICATION",
  PARTY_NOTIFICATION = "PARTY_NOTIFICATION"
}

export enum TASKSTATUS {
  SCHEDULED = "SCHEDULED",
  OPEN = "OPEN",
  CLOSED = "CLOSED"
}



@entityConfig()
export class EventType extends DomainAncestor {

  @observable eventTypeId?: string;
  @observable eventName?: string;
  @observable comment?: string;
  @observable eventType?: LovItem;
  @observable eventCategory?: LovItem;
  @observable tenantGroups?: number[];
  @observable tenants?: number[];
  @observable gridLocations: string[];
  @observable smsDeliveryReceipt?: boolean;
  @observable smsDeliveryFailureAlert?: LovItem;


  constructor(json: IDomainObject) {
    super(json);

    if (!this.tenantGroups) this.tenantGroups = [];
    if (!this.tenants) this.tenants = [];
    if (!this.gridLocations) this.gridLocations = [];

  }


  public getId(): ID {
    return this.eventTypeId;
  }

  public setId(id: ID): void {
    this.eventTypeId = <any>id;
  }

}

@entityConfig()
export class EventTemplate extends DomainAncestor {

  @observable eventType: LovItem;
  @observable comment: string;
  @observable validFrom: string|Date;
  @observable validTo: string|Date;
  @observable profitCenter: LovItem;
  @observable language: LovItem;
  @observable defaultEmailSubject: string;
  @observable defaultEmailBody: string;
  @observable templateIndex: number;
  @observable emailFrom: string;
  @observable replyTo: string;
  @observable cc: string;
  @observable bcc: string;
  @observable toAddress: string;
  @observable toAddressCode: LovItem;

  @observable $testObject: EventTest;

  @observable invoiceTypeIds: LovItem[];

  @observable @fieldInfo(DocumentTemplateResource)  resources: ObservableMap<DocumentTemplateResource>;

  constructor(json: IDomainObject) {
    super(json);

  }

  public fromJson(json: any): this {
    super.fromJson(json, "resources");

    if (!this.resources) this.resources = new ObservableMap<DocumentTemplateResource>();
    if (!this.invoiceTypeIds) this.invoiceTypeIds = [];

    return this;
  }

  // musi zmenit klic mapy dle jmena uvnitr
  public prepareForServer(): this {
    this.resources = observable.map<DocumentTemplateResource>(this.resources.values().reduce((acc: any, value: DocumentTemplateResource) => {
      acc[value.name] = value;
      return acc;
    }, {}));
    return super.prepareForServer();
  }
}

@entityConfig()
export class EventTest extends DomainAncestor {

  @observable $eventHistory: EventHistory;
  @observable.ref $mdEntity: MdEntity;
  @observable.ref $testObject: any;
  @observable $sendEmail: boolean;


  constructor(json?: IDomainObject) {
    super(json);
  }
}



@entityConfig()
export class SmsMessage extends DomainAncestor {

  @observable messageId: string;
  @observable smsprovider: string;
  @observable smsText: string;
  @observable toNumber: string;
  @observable eventType: LovItem;
  @observable success: boolean;
  @observable errorCode: string;
  @observable errorDescription: string;
  @observable deliverySuccess: boolean;
  @observable deliveryTime: string;
  @observable deliveryErrorCode: string;
  @observable deliveryErrorDescription: string;


  constructor(json: IDomainObject) {
    super(json);
  }

  public getId(): ID {
    return this.messageId;
  }

  public setId(id: ID): void {
    this.messageId = <any>id;
  }

}


@entityConfig()
export class ViberMessage extends DomainAncestor {

  @observable messageId: string;
  @observable messageText: string;
  @observable toUserId: string;
  @observable eventType: LovItem;
  @observable success: boolean;
  @observable errorCode: string;
  @observable errorDescription: string;
  @observable deliverySuccess: boolean;


  constructor(json: IDomainObject) {
    super(json);
  }

  public getId(): ID {
    return this.messageId;
  }

  public setId(id: ID): void {
    this.messageId = <any>id;
  }

}


@entityConfig()
export class EmailRecipient extends DomainAncestor {

  @observable recipientType: RECIPIENTTYPE;
  @observable emailAddress: string;

  constructor(json: IDomainObject) {
    super(json);
  }
}





@entityConfig()
export class HistoryObjectField extends DomainAncestor {

  @observable historyObject: number;
  @observable fieldName: string;
  @observable oldValue: string;
  @observable newValue: string;
  // @observable oldValueObject: DomainAncestor;
  // @observable newValueObject: DomainAncestor;

  constructor(json: IDomainObject) {
    super(json);
  }

}

@entityConfig()
export class HistoryObject extends DomainAncestor {

  @observable historyObjectId: number;
  @observable eventHistory: number;
  @observable entityId: string;
  @observable entityName: string;
  @observable parentEntityId: string;
  @observable parentEntityName: string;
  @observable operation: DMLOPERATION;
  @observable version: number;
  @observable entityLabel: string;
  @observable @fieldInfo(HistoryObjectField) fields: HistoryObjectField[];
  @observable @fieldInfo((ho) => {
    let entityConfig = mdEntityService.getEntityConfig(ho.entityName);
    if (!entityConfig) throw new Error("EntityConfig for " + ho.entityName + " not found in Registry");
    return entityConfig.entityConstructorFunction;
  }) fullObject: DomainAncestor;

  constructor(json: any) {
    super(json);

    if (!this.fields) this.fields = [];
  }

  public getId(): ID {
    return this.historyObjectId;
  }

  public setId(id: ID): void {
    this.historyObjectId = <any>id;
  }

}

@entityConfig()
export class EventHistory extends DomainAncestor {

  @observable eventHistoryId: number;
  @observable entityId: string;
  @observable entityName: string;
  @observable eventCategory: EVENTCATEGORY;
  @observable eventType: LovItem;

  @observable @fieldInfo(HistoryObject) historyObjects: HistoryObject[];
  @observable @fieldInfo(EmailRecipient) emailRecipients: EmailRecipient[];

  @observable emailFrom: string;
  @observable emailSubject: string;
  @observable emailBody: string;
  @observable message: string;
  @observable toNumber: string;
  @observable @fieldInfo(SmsMessage) smsMessage: SmsMessage;
  @observable @fieldInfo(SmsMessage) viberMessage: ViberMessage;

  @observable @fieldInfo(Document) documents: Document[];

  constructor(json: any) {
    super(json);

    if (!this.historyObjects) this.historyObjects = [];
    if (!this.emailRecipients) this.emailRecipients = [];
    if (!this.documents) this.documents = [];
  }


  public getId(): ID {
    return this.eventHistoryId;
  }

  public setId(id: ID): void {
    this.eventHistoryId = <any>id;
  }


}








@entityConfig()
export class ActivityConfig extends DomainAncestor {

  @observable activityConfigId?: string;
  @observable activityName?: string;
  @observable comment?: string;
  @observable activityType?: LovItem;
  @observable activityCategory?: LovItem;
  @observable rootEntity?: LovItem;
  @observable tenantGroups?: number[];
  @observable tenants?: number[];
  @observable gridLocations: string[];
  @observable location?: LovItem;


  constructor(json: any) {
    super(json);

    if (!this.tenantGroups) this.tenantGroups = [];
    if (!this.tenants) this.tenants = [];
    if (!this.gridLocations) this.gridLocations = [];

  }


  public getId(): ID {
    return this.activityConfigId;
  }

  public setId(id: ID): void {
    this.activityConfigId = <any>id;
  }

}

@entityConfig()
export class ActivityTemplate extends DomainAncestor {

  @observable activityConfig: LovItem;
  @observable comment: string;
  @observable validFrom: string|Date;
  @observable validTo: string|Date;
  @observable language: LovItem;
  @observable profitCenter: LovItem;
  @observable defaultEmailSubject: string;
  @observable defaultEmailBody: string;
  @observable templateIndex: number;
  @observable emailFrom: string;
  @observable replyTo: string;
  @observable cc: string;
  @observable bcc: string;
  @observable toAddress: string;
  @observable activityPaths: LovItem;
  @observable backOfficeEmail: string;
  @observable defaultEmailDesign: string;


  @observable @fieldInfo(DocumentTemplateResource)  resources: ObservableMap<DocumentTemplateResource>;

  constructor(json: any) {
    super(json);
  }

  public fromJson(json: any): this {
    super.fromJson(json, "resources");

    if (!this.resources) this.resources = new ObservableMap<DocumentTemplateResource>();

    return this;
  }

  // musi zmenit klic mapy dle jmena uvnitr
  public prepareForServer(): this {
    this.resources = observable.map<DocumentTemplateResource>(this.resources.values().reduce((acc: any, value: DocumentTemplateResource) => {
      acc[value.name] = value;
      return acc;
    }, {}));
    return super.prepareForServer();
  }

}



@entityConfig()
export class PartyActivityObject extends DomainAncestor {
  @observable partyActivityObjectId: number;
  @observable partyActivity: number;
  @observable entityId: string;
  @observable entityName: string;
  @observable fullObject: LovItem;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.partyActivityObjectId;
  }

  public setId(id: ID): void {
    this.partyActivityObjectId = <any>id;
  }

}

export const toEmailAddress = (emailRecipients: EmailRecipient[]): string[] => (emailRecipients) ? emailRecipients.filter( er => er.recipientType === RECIPIENTTYPE.TO).map(er => er.emailAddress) : [];
export const ccEmailAddress = (emailRecipients: EmailRecipient[]): string[] => (emailRecipients) ? emailRecipients.filter( er => er.recipientType === RECIPIENTTYPE.CC).map(er => er.emailAddress) : [];
export const bccEmailAddress = (emailRecipients: EmailRecipient[]): string[] => (emailRecipients) ? emailRecipients.filter( er => er.recipientType === RECIPIENTTYPE.BCC).map(er => er.emailAddress) : [];

@entityConfig()
export class PartyActivity extends DomainAncestor {

  @observable partyActivityId: number;
  @observable businessDate: string|Date;
  @observable activityConfig: LovItem;
  @observable activityType: LovItem;
  @observable activityCategory?: LovItem;
  @observable customer: LovItem;
  @observable persons: (LovItem & {_emailAddresses?: string[]}) [];
  @observable @fieldInfo(PartyActivityObject) objects: PartyActivityObject[];
  @observable emailSubject: string;
  @observable emailBody: string;
  @observable emailFrom: string;
  @observable replyTo: string;
  @observable activitySent: string|Date;
  @observable @fieldInfo(EmailRecipient) emailRecipients: EmailRecipient[];

  constructor(json: any) {
    super(json);
    if (!this.emailRecipients) this.emailRecipients = [];
    if (!this.objects) this.objects = [];

  }


  public getId(): ID {
    return this.partyActivityId;
  }

  public setId(id: ID): void {
    this.partyActivityId = <any>id;
  }

  public getTo(): string[] {
    return toEmailAddress(this.emailRecipients);
  }
  public getCc(): string[] {
    return ccEmailAddress(this.emailRecipients);
  }
  public getBcc(): string[] {
    return bccEmailAddress(this.emailRecipients);
  }

}

export interface WithActive {
  active: boolean;
  closeDate?: string|Date;
}


export class EntityStatus extends DomainAncestor {
  @observable entityObject?: LovItem;
  @observable messages?: ValidationMessage[];
  @observable emails?: string[];
  @observable status?: SEVERITY;
  @observable partyActivity?: PartyActivity;
  @observable operation?: DMLOPERATION;

  constructor(json: any) {
    super(json);
  }

}


export class GridActivityDto extends DomainAncestor {

  @observable activityConfigId: string;
  @observable gridId: number;
  @observable type: LovItem;
  @observable subjectTemplate: string;
  @observable bodyTemplate: string;
  @observable @fieldInfo(EntityStatus) statuses: EntityStatus[];
  @observable gridParams: GridParams;
  @observable part: number;
  @observable showErrors: boolean;


  constructor(json: any) {
    super(json);
  }


}







export class TaskDto extends DomainAncestor {

  @observable type: LovItem;
  @observable taskType: LovItem;
  @observable subjectTemplate: string;
  @observable bodyTemplate: string;
  @observable scheduledDate: Date|string;
  @observable @fieldInfo(EntityStatus) statuses: EntityStatus[];

  @observable $scheduledDateError: string;


  constructor(json: any) {
    super(json);
    if (!this.statuses) this.statuses = [];
  }

}


@entityConfig()
export class TaskNote extends DomainAncestor {

  @observable taskNoteId: number;
  @observable content: string;
  @observable task: LovItem;
  @observable closingNote: boolean;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.taskNoteId;
  }

  public setId(id: ID): void {
    this.taskNoteId = <any>id;
  }
}

@entityConfig()
export class TaskObject extends DomainAncestor {
  @observable taskObjectId: number;
  @observable task: number;
  @observable entityId: string;
  @observable entityName: string;
  @observable fullObject: LovItem;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.taskObjectId;
  }

  public setId(id: ID): void {
    this.taskObjectId = <any>id;
  }
}

@entityConfig(undefined, "taskDetail")
export class Task extends DomainAncestor {

  @observable taskId: number;
  @observable name: string;
  @observable scheduledDate: Date|string;
  @observable activityConfig: LovItem;
  @observable taskType: LovItem;
  @observable taskStatus: LovItem;
  @observable customer: LovItem;
  @observable owner: LovItem;
  @observable closingDate: Date|string;

  @observable @fieldInfo(TaskNote) notes: TaskNote[];
  @observable @fieldInfo(PartyActivity) partyActivities: PartyActivity[];
  @observable @fieldInfo(TaskObject) objects: TaskObject[];


  @observable persons: LovItem[];


  constructor(json: any) {
    super(json);
    if (!this.notes) this.notes = [];
    if (!this.persons) this.persons = [];
    if (!this.partyActivities) this.partyActivities = [];
    if (!this.objects) this.objects = [];
  }


  public getId(): ID {
    return this.taskId;
  }

  public setId(id: ID): void {
    this.taskId = <any>id;
  }

}




// WEBPACK FOOTER //
// ./src/core/event/eventDomain.ts